(function () {
  let selectedStoreEmail = null;

  function show(el) {
    if (!el) return;
    el.hidden = false;
    el.style.display = 'block';
  }

  function hide(el) {
    if (!el) return;
    el.hidden = true;
    el.style.display = 'none';
  }

  function initEreservation() {
    const root = document.querySelector('[data-mm-ereservation]');
    if (!root || root.dataset.mmEreservationInit === 'true') return;
    root.dataset.mmEreservationInit = 'true';

    const configNode = root.querySelector('[data-mm-ereservation-config]');
    if (!configNode) return;

    let config = null;
    try {
      config = JSON.parse(configNode.textContent);
    } catch (e) {
      console.error('MM e-reservation config parse error', e);
      return;
    }

    const WORKER_URL = config.workerUrl;
    const RESERVATION_URL = config.reservationUrl;
    const THANK_YOU_URL = config.thankYouUrl || '/pages/merci';
    const STORES = config.stores || {};
    const STORE_ADDRESSES = config.storeAddresses || {};
    const STORE_HOURS = config.storeHours || {};
    const PRODUCT_COLOR = config.productColor || '';
    const openBtn = document.getElementById('faire-venir-boutique');
    const modal = document.getElementById('reservation-modal');
    const closeBtn = document.getElementById('close-modal');
    const loadingText = document.getElementById('loading-text');
    const storeList = document.getElementById('store-list');
    const formWrapper = document.getElementById('reservation-form-wrapper');
    const form = document.getElementById('faire-venir-form');
    const selectedStore = document.getElementById('selected-store');
    const reservationDuration = document.getElementById('reservation-duration');
    const infoBtn = document.getElementById('ereservation-info');
    const infoModal = document.getElementById('ereservation-info-modal');
    const closeInfo = document.getElementById('close-info-modal');
    const submitBtn = document.getElementById('submit-reservation');

    let availableStores = [];
    let showAllStores = false;

    function resetModal() {
      selectedStoreEmail = null;
      show(selectedStore ? storeList : storeList);
      hide(selectedStore);
      hide(formWrapper);
      hide(reservationDuration);
      if (selectedStore) selectedStore.innerHTML = '';
      if (storeList) storeList.innerHTML = '';
    }

    async function loadStores() {
      availableStores = [];
      showAllStores = false;
      storeList.innerHTML = '';
      hide(formWrapper);
      show(loadingText);

      const variantId = document.querySelector("[name='id']")?.value;
      if (!variantId) {
        loadingText.innerText = 'Erreur : variante introuvable.';
        return;
      }

      try {
        const calls = Object.keys(STORES).map((storeName) =>
          fetch(`${WORKER_URL}?variantId=${variantId}&store=${encodeURIComponent(storeName)}`)
            .then((r) => r.json())
            .then((data) => ({
              name: storeName,
              email: STORES[storeName],
              quantity: Number(data.quantity) || 0,
              available: data.available,
              address: STORE_ADDRESSES[storeName]
            }))
            .catch(() => null)
        );

        const results = await Promise.all(calls);

        availableStores = results
          .filter((r) => r && r.available && r.quantity > 0)
          .sort((a, b) => {
            const qa = Number(a.quantity) || 0;
            const qb = Number(b.quantity) || 0;
            return qb - qa;
          });
      } catch (e) {
        console.error(e);
      }

      hide(loadingText);

      if (!availableStores.length) {
        storeList.innerHTML = '<p>Aucune boutique disponible.</p>';
        return;
      }

      renderStores();
    }

    function renderStores() {
      storeList.innerHTML = '';

      const list = showAllStores ? availableStores : availableStores.slice(0, 3);

      list.forEach((store) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.innerText = `${store.name} — ${store.quantity} en stock`;
        btn.onclick = () => selectStore(store);
        storeList.appendChild(btn);
      });

      if (!showAllStores && availableStores.length > 3) {
        const more = document.createElement('button');
        more.type = 'button';
        more.id = 'show-more-stores';
        more.innerText = 'Voir plus de boutiques';
        more.onclick = () => {
          showAllStores = true;
          renderStores();
        };
        storeList.appendChild(more);
      }
    }

    function selectStore(store) {
      selectedStoreEmail = store.email;

      hide(storeList);
      show(selectedStore);

      selectedStore.innerHTML = `
        <h4>Boutique sélectionnée</h4>
        <strong>${store.name}</strong>
        ${store.address}
        ${STORE_HOURS[store.name] ? `
          <div class="store-hours">
            <strong>Horaires d’ouverture</strong>
            <div class="hours-list">${STORE_HOURS[store.name]}</div>
          </div>
        ` : ''}
        <div class="store-actions">
          <a
            class="maps-link"
            href="https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(store.address)}"
            target="_blank"
          >
            📍 Itinéraire Google Maps
          </a>
          <button id="change-store" type="button">Changer de boutique</button>
        </div>
      `;

      show(formWrapper);
      setTimeout(() => formWrapper.classList.add('is-visible'), 10);
      formWrapper.scrollIntoView({ behavior: 'smooth' });
      show(reservationDuration);

      document.getElementById('change-store').onclick = () => {
        hide(selectedStore);
        show(storeList);
        hide(formWrapper);
        hide(reservationDuration);
      };
    }

    async function sendReservation() {
      const btn = document.getElementById('submit-reservation');

      btn.disabled = true;
      btn.textContent = 'Envoi en cours...';

      if (!selectedStoreEmail) {
        alert('Merci de sélectionner une boutique.');
        btn.disabled = false;
        btn.textContent = 'Envoyer ma demande';
        return;
      }

const data = {
  storeEmail: selectedStoreEmail,
  product: document.getElementById('product_name').value,
  size: document.getElementById('product_size').value,
  color: PRODUCT_COLOR,
  name: form.querySelector('[name="client_name"]').value,
  email: form.querySelector('[name="client_email"]').value,
  phone: form.querySelector('[name="client_phone"]').value,
  message: form.querySelector('[name="message"]').value || '',
  productUrl: window.location.href
};

      try {
        const res = await fetch(RESERVATION_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        });

        const json = await res.json().catch(() => ({}));

        if (!res.ok) {
          console.error('Worker error:', json);
          throw new Error(json?.error || 'Erreur lors de l’envoi');
        }

        window.location.href = THANK_YOU_URL;
      } catch (e) {
        console.error(e);
        alert('Une erreur est survenue. Merci de réessayer.');
        btn.disabled = false;
        btn.textContent = 'Envoyer ma demande';
      }
    }

    openBtn?.addEventListener('click', () => {
      show(modal);
      loadStores();
    });

    closeBtn?.addEventListener('click', () => {
      hide(modal);
      resetModal();
    });

    modal?.addEventListener('click', (e) => {
      if (e.target === modal) {
        hide(modal);
        resetModal();
      }
    });

    infoBtn?.addEventListener('click', () => {
      show(infoModal);
    });

    closeInfo?.addEventListener('click', () => {
      hide(infoModal);
    });

    infoModal?.addEventListener('click', (e) => {
      if (e.target === infoModal) {
        hide(infoModal);
      }
    });

    submitBtn?.addEventListener('click', () => {
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const productTitle = document.querySelector('h1')?.innerText.trim() || '';

      let size = '';
      size = document.querySelector('[aria-pressed="true"]')?.innerText.trim() || size;
      size = document.querySelector('.is-selected')?.innerText.trim() || size;
      size = document.querySelector("input[type='radio']:checked")?.value || size;

      if (!size) {
        alert('Merci de sélectionner une pointure.');
        return;
      }

      document.getElementById('product_name').value = productTitle;
      document.getElementById('product_size').value = size;

      sendReservation();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEreservation);
  } else {
    initEreservation();
  }
})();